import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1722587561829-8a53e1935e20?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxpdGFsaWFuJTIwcmVzdGF1cmFudCUyMGludGVyaW9yfGVufDB8fHx8MTc3NjIwMzY5M3ww&ixlib=rb-4.1.0&q=85"
                alt="Interior Obrador Pomodoro"
                className="w-full h-[500px] object-cover transform hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-[#C1272D]/10 rounded-full blur-3xl -z-10"></div>
          </div>

          <div>
            <h2
              className="text-4xl md:text-5xl font-bold text-gray-900 mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Sobre Nosotros
            </h2>
            <div className="space-y-4 text-gray-700 text-lg leading-relaxed">
              <p>
                En <span className="font-semibold text-[#C1272D]">Obrador Pomodoro</span>, 
                llevamos la auténtica tradición italiana al corazón de Rosario. Somos más que 
                un restaurante: somos un espacio donde la calidad de la comida se encuentra 
                con una ambientación cuidada y una experiencia completa.
              </p>
              <p>
                Nuestro compromiso es ofrecerte platos elaborados con ingredientes de primera 
                calidad, siguiendo recetas tradicionales italianas con un toque contemporáneo. 
                Cada pasta, cada salsa, cada pan que sale de nuestro obrador es preparado con 
                dedicación y pasión.
              </p>
              <p>
                Ya sea para un almuerzo de trabajo, una cena romántica o una celebración 
                especial, <span className="font-semibold">Obrador Pomodoro</span> te ofrece 
                el ambiente perfecto. Nuestra ambientación moderna y cálida, combinada con 
                un servicio excepcional, garantiza que cada visita sea memorable.
              </p>
              <div className="pt-4 border-t border-gray-200 mt-6">
                <p className="font-semibold text-[#C1272D] text-xl">
                  "Donde la tradición italiana se encuentra con la hospitalidad rosarina"
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
